import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const PlaceTopIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M19.3604 12.001V10.6396C19.3602 7.32616 16.6739 4.63976 13.3604 4.63965H10.6396C7.32627 4.63991 4.6408 7.32625 4.64062 10.6396V12.001H19.3604Z" fill="currentColor" />;
    t1 = <path d="M4 15C4 17.7614 6.23858 20 9 20H15C17.7614 20 20 17.7614 20 15V9C20 6.23858 17.7614 4 15 4H9C6.23858 4 4 6.23858 4 9V15ZM5.5 9C5.5 7.067 7.067 5.5 9 5.5H15C16.933 5.5 18.5 7.067 18.5 9V15C18.5 16.933 16.933 18.5 15 18.5H9C7.067 18.5 5.5 16.933 5.5 15V9Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default PlaceTopIcon;